import "./FormError.css";
const FormError = ({ children }) => {
  return <p className="txt-left form-error txt-semibold ml-2">{children}</p>;
};

export { FormError };
